<template>
    <modal name="daum-postcode-modal" class="daum-postcode-modal"
           :width="600"
           :height="600"
           @before-open="handlerBeforeOpen"
           @before-close="handlerBeforeClose"
    >
        <div>
            <div class="keymodal_title">
                <div class="out_title">주소검색 </div>
            </div>
            <button class="close_btn" @click="backEvent"></button>
        </div>
        <vue-daum-postcode v-if="setModal" @complete="selectAddress($event)"
                           :noSubmitMode="true" style="height: 560px; overflow: scroll;"/>
    </modal>
</template>
<script>
import EventBus from "@/mixins/event-bus";
import util from "@/mixins/util";
export default {
    name: "DaumPostcodeModal",
    mixins: [],
    components: {
    },
    props: {},
    data() {
        return {
            addressObj: {},
            searchCnt: 0,
            setModal: false,

            afterSetDataName: 'setAddress',
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {

    },
    methods: {
        backEvent() {
            this.$modal.hide('daum-postcode-modal');
        },
        selectAddress(addrObj) {
            this.addressObj = addrObj;
            EventBus.$emit(this.afterSetDataName, this.addressObj);
            this.$nextTick(() => {
                this.backEvent();
            })
        },

        handlerBeforeOpen(event) {
            this.setModal = true;
            if(event.params.hasOwnProperty('afterSetDataName') && !util.isEmpty(event.params.afterSetDataName)){
                this.afterSetDataName = event.params.afterSetDataName
            }
        },
        handlerBeforeClose() {
            this.setModal = false;
            this.setAddress = 'setAddress';
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
